const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { ...state, [action.modal]: true };
    case 'CLOSE_MODAL':
      return { ...state, [action.modal]: false };
    case 'CLEAR':
      return initialState;
    default:
      return state;
  }
}
